// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2ke-Q","info":"Note_info__21aI9","note":"Note_note__1LUfK","actions":"Note_actions__OEd5U"};